module.exports = __webpack_public_path__ + "media/enternubii.585820e2.mp3";